export const RENDER_PDF = 'render-pdf'
export const RECEIPTS = 'receipts'

export const ENDPOINTS = {
  GET_PDF: `/${RENDER_PDF}`,
  GET_PDF_IMAGE: `/${RENDER_PDF}/pdf-to-image`,
  GET_ANNUAL_RECEIPT_NUMBER: `/${RECEIPTS}/annual`,
  SEND_RECEIPT: `/${RECEIPTS}/send-receipt`,
  SEND_ANNUAL_REPORT: `/${RECEIPTS}/send-annual-report`,
  SEND_BULK_ANNUAL_REPORTS: `/${RECEIPTS}/send-bulk-annual-reports`,
  SEND_BULK_RECEIPTS: `/${RECEIPTS}/send-bulk-receipts`,
  DOWNLOAD_RECEIPT: `/${RECEIPTS}/download-receipt`,
}
